import React, {PureComponent} from 'react';
import {CSSTransition} from './CSSTransition';
import {withTranslation} from 'react-i18next';


import Keyboard from './Keyboard';
import ListingRow from './ListingRow';
import ListingHeader from './ListingHeader';
import WayfindingModal from './WayfindingModal';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSearch} from '@fortawesome/free-solid-svg-icons';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {faPause} from '@fortawesome/free-solid-svg-icons';
import {faPlay} from '@fortawesome/free-solid-svg-icons';
import {faArrowRight} from '@fortawesome/free-solid-svg-icons';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons';
import {dlListingSelect, dlSearch} from '../DataLayer';
import {buildSearchCells, makeSortKeyIndices, makeSortedDirs, makeSortedDirsForIndices, matchListingRow, sortListingsByCols} from '../util/listings';
import DetailActionContext from '../util/DetailActionContext';
import { addComposedClasses, removeComposedClasses } from '../util/classList';
import { TOUCH_ACTION_DIRECT_WAYFINDING, isWayfindingModalAction } from '../util/touchActions';

class Listings extends PureComponent {
	static contextType = DetailActionContext;

	constructor(props) {
		super(props);

		this.state = {
			activeButton:         '',
			adaTopPad:            0,
			columnWidths:         ['0'],
			css:                  props.CSSModules['Listings'],
			currentListings:      [ [''] ],
			currentHeader:        [''],
			defaultList:          this.props.defaultListName,
			details:              [],
			detailsPage:          false,
			detailsUUID:          '',
			filteredListings:     [],
			isScrolling:          false,
			listingsNavButtons:   [],
			searchInputValue:     '',
			searchUpdater:        0,
			textAlign:            [],
			boxStyleDisplay:      false,
			listingLogo:          [],
			boxColumnsPerRow:     3,
			boxActiveLayout:      0,
			transitions:          true,
			// Pagination state
			paginationEnabled:    false,
			paginationInitialized: false,
			currentPage:          0,
			autoFlipEnabled:      false,
			autoFlipInterval:     5000,
			calculatedItemsPerPage: 10,
			autoFlipProgress:     0,
			autoFlipTimeRemaining: 0,
			paginationControlsVisible: false, // Flag for fade-in transition
			listingsVisible: false, // Flag for listings fade-in transition
			isKeyboardHidden: false, // Keyboard starts visible by default
			// Wayfinding modal state
			showWayfindingModal:  false,
			wayfindingModalUUID:  '',
			wayfindingModalDetailsGrp: []
		};
		this.scrollTimeout = null;
		this.scrollWindow = React.createRef();
		this.scrollUpBtn = React.createRef();
		this.scrollDownBtn = React.createRef();
		this.listingsContainerRef = React.createRef();
		this.keyboardComponent = React.createRef();
		this.activeScrollTimers = new Set();
		this.paginationTimer = null;
		this.progressTimer = null;
		this.autoFlipStartTime = null;
		this.userPausedAutoFlip = false;
		this.wayfindingModalCloseTimer = null;
		this.startScrolling = this.startScrolling.bind(this);
		this.stopScrolling = this.stopScrolling.bind(this);
		this.nextPage = this.nextPage.bind(this);
		this.prevPage = this.prevPage.bind(this);
		this.startAutoFlip = this.startAutoFlip.bind(this);
		this.stopAutoFlip = this.stopAutoFlip.bind(this);

		this.contentRef = React.createRef();
		this.wrapperRef = React.createRef();
		this.scrollerRef = React.createRef();
		this.wayfindingModalRef = React.createRef();
	}

	handleAdaListingsPadding = () => {
		let listingsContainerHeight = this.scrollWindow.current.getBoundingClientRect().height;
		let adaTopPad = listingsContainerHeight - (window.innerHeight >= 2160 ? 600 : 300);
		this.setState({
			adaTopPad: adaTopPad
		});
		document.getElementById('listingsScroller').scrollTo({
			top: 0
		});
	}

	componentDidMount() {
		this.buildListingsNav();
		this.setCurrentListings(this.state.defaultList, () => this.initializePaginationSettings());
		
		// Pass openWayfindingModal method to parent via callback
		if (this.props.setOpenWayfindingModalRef) {
			this.props.setOpenWayfindingModalRef(this.openWayfindingModal);
		}

		let etlData = this.props.defaultList.listings;
		window.completeListings = [];

		// temporary hack fix via timeout
		setTimeout(() => {
			window.completeListings.length = 0; // Clear the array completely
			this.state.listingsNavButtons.forEach((navButtonObj, i) => {
				window.completeListings.push({category: navButtonObj.dataName, listings: []});
				this.getCompleteListings(etlData, navButtonObj.dataName);
				window.completeListings[i].listings = Array.from(new Set(window.completeListings[i].listings.map(JSON.stringify)), JSON.parse);
			});

		}, 1000);

		if (this.props.navProps.adaActive) {
			setTimeout(() => {
				this.handleAdaListingsPadding();
			}, 500);
		}

		this.resizeObserver = new ResizeObserver(() => {
			const { css } = this.state;

			if (!(this.scrollUpBtn.current && this.scrollDownBtn.current && css.disabledButton)) {
				return;
			}

			if (this.scrollWindow.current?.scrollHeight > this.scrollWindow.current?.clientHeight) {
				removeComposedClasses(this.scrollUpBtn.current, css.disabledButton);
				removeComposedClasses(this.scrollDownBtn.current, css.disabledButton);
			} else if (this.scrollWindow.current?.scrollHeight <= this.scrollWindow.current?.clientHeight) {
				addComposedClasses(this.scrollUpBtn.current, css.disabledButton);
				addComposedClasses(this.scrollDownBtn.current, css.disabledButton);
			}
		});

		this.resizeObserver.observe(this.scrollWindow.current);
	}

	componentWillUnmount() {
		if (this.scrollTimeout) {
			clearTimeout(this.scrollTimeout);
		}
		if (this.paginationTimer) {
			clearTimeout(this.paginationTimer);
		}
		if (this.progressTimer) {
			clearInterval(this.progressTimer);
		}
		if (this.recalculateTimeout) {
			clearTimeout(this.recalculateTimeout);
		}
		if (this.wayfindingModalCloseTimer) {
			clearTimeout(this.wayfindingModalCloseTimer);
		}

		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
			this.resizeObserver = null;
		}
		
		if (this.dynamicPaginationObserver) {
			this.dynamicPaginationObserver.disconnect();
			this.dynamicPaginationObserver = null;
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.navProps.resetListings !== this.props.navProps.resetListings && this.props.navProps.resetListings === true) {
			this.setCurrentListings(this.state.defaultList, () => this.initializePaginationSettings());
			this.props.closeDetailsPage();
			this.props.setDetailsTitle('');
			this.props.setTieredHeadersAndDetails([], []);
			this.props.setHistory([]);
			this.props.navEvents('setHasNavigatedListings', false);
		}
		if (prevProps.navProps.adaActive !== this.props.navProps.adaActive) {
			if (this.props.navProps.adaActive === true) {
				this.stopAutoFlip();
				// Ensure pagination controls are hidden when ADA is turned on
				if (this.state.paginationEnabled) {
					this.setPaginationVisibility(false);
				}
				setTimeout(() => {
					this.handleAdaListingsPadding();
				}, 500);
			} else {
				setTimeout(() => {
					this.setState({
						adaTopPad: 0
					});
					document.getElementById('listingsScroller').scrollTo({
						top: 0
					});
					// Restore pagination visibility when ADA is turned off
					if (this.state.paginationEnabled) {
						this.setPaginationVisibility(true);
					}
					if (this.state.paginationEnabled && this.state.autoFlipEnabled) {
						this.startAutoFlip(true);
					}
				}, 500);
			}
		}

		if (prevProps.defaultList !== this.props.defaultList) {
			// Rebuild the category nav so newly-empty / newly-populated categories
			// appear/disappear after a passive refresh. The setTimeout below reads
			// this.state.listingsNavButtons one tick later, so the setState here
			// will have applied by the time the corpus rebuild runs.
			this.buildListingsNav();

			let etlData = this.props.defaultList.listings;
			window.completeListings = [];

			// temporary hack fix via timeout
			setTimeout(() => {
				window.completeListings.length = 0; // Clear the array completely
				this.state.listingsNavButtons.forEach((navButtonObj, i) => {
					window.completeListings.push({category: navButtonObj.dataName, listings: []});
					this.getCompleteListings(etlData, navButtonObj.dataName);
					window.completeListings[i].listings = Array.from(new Set(window.completeListings[i].listings.map(JSON.stringify)), JSON.parse);
				});

			}, 1000);
		}

		if ((this.props.navProps.timeoutStatus !== prevProps.navProps.timeoutStatus && !this.props.navProps.timeoutStatus) && this.props.navProps.animationPhase === this.props.navProps.animationStartPhase) {
			this.setCurrentListings(this.state.defaultList, () => this.initializePaginationSettings());
			// Close wayfinding modal on timeout. Only App's idle-reset code ever
			// emits this edge, so this close is idle-driven too and must stay
			// silent (DEV-12143 / KB rule 9).
			if (this.state.showWayfindingModal) {
				this.closeWayfindingModal({ fromIdle: true });
			}
		}

		// The timeoutStatus edge above is gated on the start phase, which
		// persistent (unmount_group=false) listing groups on a custom phase name
		// may not satisfy — mapModalActive dropping is the backstop signal that
		// the page no longer expects the modal (DEV-12143).
		// Silent by design: an idle reset is the main cause of the drop, and
		// pinging idleTimer here would dismiss the idle prompt and cancel the
		// pending return-home that the reset is performing. The other causes
		// (setPhaseSetMenu, closeDirectWayfindingModal,
		// closeFeatureGroupWayfindingModal) each ping idleTimer themselves, so
		// nothing is lost by staying quiet here either.
		if (prevProps.navProps.mapModalActive && !this.props.navProps.mapModalActive && this.state.showWayfindingModal) {
			this.closeWayfindingModal({ fromIdle: true });
		}

		if ((prevProps.defaultList !== this.props.defaultList)) {
			// Passive data refresh (real ETL push or ListingsScroller's 15-min
			// scheduling tick). Preserve the user's autoflip clock if it's running.
			this.setCurrentListings(this.state.defaultList, () => this.initializePaginationSettings(), { preserveAutoFlip: true });
		}

		if (prevState.filteredListings !== this.state.filteredListings) {
			if (this.state.searchInputValue !== '') {
				dlSearch({
					searchTerm:      this.state.searchInputValue,
					numberOfResults: this.state.filteredListings.reduce((accum, curr) => {
						return accum + curr.listings.length;
					}, 0)
				});
			}
		}

		if (this.state.paginationEnabled && (prevState.currentListings !== this.state.currentListings || 
				prevState.filteredListings !== this.state.filteredListings ||
				prevState.searchInputValue !== this.state.searchInputValue)) {
			// Only reset if search input changed or listings length changed and current page is now out of bounds
			const listingsChanged = prevState.currentListings.length !== this.state.currentListings.length;
			const searchChanged = prevState.searchInputValue !== this.state.searchInputValue;
			const currentListings = this.state.currentListings;
			const totalPages = this.calculateTotalPages(currentListings);

			if (
				searchChanged ||
				(listingsChanged && this.state.currentPage >= totalPages)
			) {
				this.setState({ currentPage: 0 });
			}
			
			if (prevState.searchInputValue !== '' && this.state.searchInputValue === '') {
				this.setPaginationVisibility(!this.props.navProps.adaActive, () => {
					setTimeout(() => {
						this.updateCalculatedItemsPerPage();
					}, 100);
				});
			} else if (this.state.searchInputValue !== '') {
				this.setPaginationVisibility(false);
			} else if (!this.props.navProps.adaActive) {
				this.setPaginationVisibility(true);
			}

			// Auto-flip logic
			if (this.state.searchInputValue !== '') {
				this.stopAutoFlip();
			}
		}

		if (this.state.paginationEnabled && (prevState.paginationEnabled !== this.state.paginationEnabled ||
			prevState.autoFlipEnabled !== this.state.autoFlipEnabled ||
			prevState.autoFlipInterval !== this.state.autoFlipInterval)) {
			
			this.stopAutoFlip();
			if (this.state.paginationEnabled && this.state.autoFlipEnabled) {
				this.startAutoFlip(true);
			}
		}

		if (this.state.paginationEnabled && (
			prevState.calculatedItemsPerPage !== this.state.calculatedItemsPerPage ||
			prevState.currentPage !== this.state.currentPage ||
			prevState.currentListings !== this.state.currentListings ||
			prevState.filteredListings !== this.state.filteredListings
		)) {
			this.adjustPageSizeForFit();
		}
	}

	findChildLabels = (listArray) => {
		let labels = window.listingsNav;

		if (Array.isArray(listArray) && listArray.length > 0) {
			listArray.forEach((item) => {
				if (item.colGroups.length > 0) {
					let name = item.colGroups[0].dataName;
					let btnObj = {
						dataName: name,
						label:    name,
						showSubNavButton: item.tierConfig?.showSubNavButton !== undefined
							? item.tierConfig.showSubNavButton
							: true
					};

					let labelOverride = item.tierConfig.mobileButtonLabel;
					if (labelOverride !== undefined && labelOverride !== null && labelOverride !== '') {
						btnObj.label = labelOverride;
					}

					if (labels.length === 0) {
						labels.push(btnObj);
					} else {
						let addToArray = true;
						// let newObj = {};
						labels.forEach((obj) => {
							// newObj = obj;
							if (obj.dataName === name || name === undefined) {
								addToArray = false;
							}
						});
						if (addToArray === true) {
							labels.push(btnObj);
						}
					}
					this.findChildLabels(item.listings);
				}
			});
		}
		return;
	}

	buildListingsNav = () => {
		// hard coded for faster testing
		window.listingsNav = [];
		let listingsData = this.props.defaultList.listings;

		this.findChildLabels(listingsData);

		this.setState({
			listingsNavButtons: window.listingsNav
		});

	}

	handleDown = (buttonId) => {
		this.setState({activeButton: buttonId});
	}

	handleUp = () => {
		if (this.state.activeButton !== '') {
			this.setState({activeButton: ''});
		}
	}

	openWayfindingModal = (rowUUID, detailsGrp) => {
		this.setState({
			showWayfindingModal: true,
			wayfindingModalUUID: rowUUID,
			wayfindingModalDetailsGrp: detailsGrp
		});
		this.props.navEvents('idleTimer', '||| Listings.js > openWayfindingModal()');
		this.props.navEvents('openMapModal');
	}

	// DEV-12172: info box CTA inside the open modal — swap it to the new listing
	// in place (detailsGrp looked up the same way ListingsDetails does for nearby
	// locations) instead of letting App.js stack its own direct modal on top.
	changeWayfindingModalListing = (listingUUID) => {
		let detailsGrp = [];
		(window.completeListings || []).forEach((listingTier) => {
			listingTier.listings.forEach((listing) => {
				if (Array.isArray(listing) && listing[0] === listingUUID) {
					detailsGrp = listing[listing.length - 1] || [];
				}
			});
		});
		this.setState({
			wayfindingModalUUID: listingUUID,
			wayfindingModalDetailsGrp: detailsGrp
		});
		this.props.navEvents('idleTimer', '||| Listings.js > changeWayfindingModalListing()');
	}

	closeWayfindingModal = ({ fromIdle = false } = {}) => {
		this.setState({
			showWayfindingModal: false,
			wayfindingModalUUID: '',
			wayfindingModalDetailsGrp: []
		});
		// Cancel any close a prior user-driven close already scheduled, so the
		// idle path below stays silent too
		if (this.wayfindingModalCloseTimer) {
			clearTimeout(this.wayfindingModalCloseTimer);
			this.wayfindingModalCloseTimer = null;
		}
		if (fromIdle) {
			// The idle system already cleared mapModalActive and is mid-reset.
			// An idleTimer ping would restart the countdown (dismissing the idle
			// prompt and cancelling its promptTimer), and closeMapModal would
			// redundantly re-clear a flag that is already false.
			return;
		}
		this.props.navEvents('idleTimer', '||| Listings.js > closeWayfindingModal()');
		// Use closeMapModal with delay to sync with modal close animation
		this.wayfindingModalCloseTimer = setTimeout(() => {
			this.props.navEvents('closeMapModal', 700);
		}, 0);
	}

	getListingConfigUUID = () => {
		const detailsUUID = this.state.wayfindingModalUUID;
		if (!detailsUUID) return '';

		for (let [m1Key, m1Data] of Object.entries(window.flatData)) {
			if (m1Key.startsWith(detailsUUID)) {
				for (let [m2Key] of Object.entries(m1Data)) {
					if (m2Key.startsWith('listing_config.')) {
						return m2Key;
					}
				}
			}
		}
		return '';
	}

	getQRTextInstruction = (listingConfigUUID) => {
		const { tmp_data_etl } = this.props;
		
		let qrText = 'Use your camera or tablet to take this map with you';
		let listingGroupUUID = '';

		for (let [m1Key, m1Data] of Object.entries(window.flatData)) {
			if (m1Key.startsWith('listing_group.')) {
				for (let [m2Key] of Object.entries(m1Data)) {
					if (m2Key.startsWith('listing_config.') && m2Key === listingConfigUUID) {
						listingGroupUUID = m1Key;
					}
				}
			}
		}

		for (let [m1Key, m1Data] of Object.entries(tmp_data_etl)) {
			if (m1Key.startsWith('listing_collection.')) {
				for (let [m2Key, m2Data] of Object.entries(m1Data.listing_groups)) {
					if (m2Key === listingGroupUUID && m2Data.qr_code_text_instruction) {
						qrText = m2Data.qr_code_text_instruction;
					}
				}
			}
		}

		return qrText;
	}

	buttonEvents = (obj) => {
		this.props.navEvents('idleTimer', '||| Listings.js > createButtons()');
		this.props.navEvents('setHasNavigatedListings', true);
		this.props.closeDetailsPage();
		this.props.setDetailsTitle('');
		this.props.setTieredHeadersAndDetails([], []);
		this.props.setHistory([]);
		this.setCurrentListings(obj.dataName);
		this.setState({searchUpdater: this.state.searchUpdater + 1});
		dlListingSelect({
			listName: obj.dataName
		});
	}

	createButtons = () => {
		let {css, activeButton} = this.state;
		let buttons = [];
		let currentSelectedNav = this.state.currentHeader[0].replace(/[\s/&:!]+/g, '');

		this.state.listingsNavButtons.forEach((obj, i) => {
			if (obj.showSubNavButton === false) {
				return;
			}
			const activeButtonClass = activeButton === obj.dataName ? `${css.activeButton} activeButton` : '';

			buttons.push(
				<div
					className={`listingsSecNavBtn ${currentSelectedNav + i} ${css.secNavBtn} ${activeButtonClass}`}
					// ------ Reverted this: Craig's touch fixes + Pedro's stopPropagation ---------------
					// onMouseDown={(e) => {
					// 	e.stopPropagation();
					// 	this.handleDown(obj.dataName);
					// 	this.props.navEvents(`btnDebouncer`, () => this.buttonEvents(obj));
					// }}
					// onMouseUp={this.handleUp}
					// onMouseLeave={this.handleUp}
					// onTouchStart={(e) => {
					// 	e.stopPropagation();
					// 	this.handleDown(obj.dataName);
					// 	this.props.navEvents(`btnDebouncer`, () => this.buttonEvents(obj));
					// }}
					// onTouchEnd={this.handleUp}
					// onPointerDown={(e) => {
					// 	e.stopPropagation();
					// 	this.handleDown(obj.dataName);
					// 	this.props.navEvents(`btnDebouncer`, () => this.buttonEvents(obj));
					// }}
					// onPointerUp={this.handleUp}
					// onPointerLeave={this.handleUp}

					// ------ Tier ButtonHotfix - reverted the code above ---------------
					onClick={(e) => {
						e.stopPropagation();
						this.props.navEvents('idleTimer', '||| Listings.js > createButtons()');
						this.props.navEvents('setHasNavigatedListings', true);
						this.props.closeDetailsPage();
						this.props.setDetailsTitle('');
						this.props.setTieredHeadersAndDetails([], []);
						this.props.setHistory([]);
						this.setCurrentListings(obj.dataName);
						this.setState({searchUpdater: this.state.searchUpdater + 1});
						dlListingSelect({
							listName: obj.dataName
						});
					}}
					onMouseDown={(e) => {
						e.stopPropagation();
						this.handleDown(obj.dataName);
					}}
					onMouseUp={this.handleUp}
					onMouseLeave={this.handleUp}
					onTouchStart={(e) => {
						e.stopPropagation();
						this.handleDown(obj.dataName);
					}}
					onTouchEnd={this.handleUp}
					key={`listBtn_${i}`}
				>{obj.label}</div>
			);
		});
		return buttons;
	}

	startScrolling = (direction) => {
		// Clear any existing timers first
		this.stopScrolling();
		
		const value = this.props.scrollButtons === 1 ? 2 : this.props.scrollDistance;
		const scrollInterval = this.props.scrollButtons === 1 ? 5 : 1000;
	
		// Do initial scroll for mode 2
		if (this.props.scrollButtons === 2) {
			this.scrollWindow.current.scrollTop += direction === 'down' ? value : -value;
		}
	
		// Create new timer
		const timerId = setInterval(() => {
			if (this.scrollWindow.current) {
			this.scrollWindow.current.scrollTop += direction === 'down' ? value : -value;
			}
		}, scrollInterval);
	
		// Store timer ID in Set
		this.activeScrollTimers.add(timerId);
	}

	stopScrolling = () => {
		// Clear all active timers
		this.activeScrollTimers.forEach(timerId => {
			clearInterval(timerId);
		});
		this.activeScrollTimers.clear();
	}
	
	handlePointerDown = (e, direction) => {
		e.preventDefault();
		// Check if it's already scrolling
		if (this.activeScrollTimers.size === 0) {
			this.startScrolling(direction);
		}
	}

	arrayDiffer = (row, arr) => {
		let itsTheSame = true;
		if (row[0] !== arr[0]) {
			itsTheSame = false;
		}
		return itsTheSame;
	}

	arrayContainsArray(arrayOfArrays, arr) {
		let equal = false;
		arrayOfArrays.forEach((row) => {
			if (Array.isArray(row) && Array.isArray(arr) && row.length === arr.length && this.arrayDiffer(row, arr)) {
				equal = true;
			}
		});
		return equal;
	}

	findListingByDataName(listings, targetDataName) {
		if (!Array.isArray(listings) || listings.length === 0) {
			return null;
		}

		for (const listing of listings) {
			if (listing.colGroups[0] && listing.colGroups[0].dataName === targetDataName) {
				return listing;
			}

			// Recursively search within nested listings
			const foundInChildren = this.findListingByDataName(listing.listings, targetDataName);
			if (foundInChildren) {
				return foundInChildren;
			}
		}

		// Return null if no matching listing is found
		return null;
	}

	getTierData = (listings, listName, addTier = false) => {
		let tier = 0;
		if (addTier) {
			tier++;
		}

		// DEV-12182: defaultList is { listings: [] } when default_list_shown cannot be resolved.
		let listInfo = this.findListingByDataName(listings, listName) || listings?.[0];
		if (!listInfo || !listInfo.colGroups || listInfo.colGroups.length === 0) {
			return null;
		}

		let sortedCols = [...listInfo.colGroups].filter((c) => {
			if (c.sort > 0) {
				return true;
			}

			return false;
		});

		sortedCols.sort((i, j) => {
			if (i.sort > j.sort) {
				return 1;
			}

			return -1;
		});

		if (!addTier) {
			window.listingsShownDirs = makeSortedDirs(sortedCols);
		}

		if (Array.isArray(listings) && listings.length > 0) {
			listings.forEach((item) => {
				if (item.colGroups[0] && item.colGroups[0].dataName === listName) {
					let row = [];
					let textAlign = [];
					let listingLogo = [];
					let headerAsLabel = [];
					let touchAction = item.tierConfig.touchAction;

					item.sortedVals = [item.rank || 0];
					for (let col of sortedCols) {
						item.sortedVals.push(item.vals[col.order - 1]);
					}

					// listings
					item.vals.forEach((listingData, i) => {
						row.push({
							value:       listingData,
							type:        item.types[i],
							displayName: item.displayNames[i],
							column_uuid: item.colGroups[i].m1Key,
							tier
						});
					});
					if (!this.arrayContainsArray(window.listingsShown, [item.m1Key, touchAction, ...row, item.tierConfig, item.detailsGrp, item.sortedVals])) {
						window.listingsShown.push([item.m1Key, touchAction, ...row, item.tierConfig, item.detailsGrp, item.sortedVals]);
					}

					// header
					let headerWidthsArr = [];
					let headerShownArr = [];

					item.colGroups.forEach((headerData) => {
						headerWidthsArr.push(headerData.width);
						headerShownArr.push(headerData.name);
					});

					this.setState({
						columnWidths:  headerWidthsArr,
						currentHeader: headerShownArr,
					});
					window.headerWidths = headerWidthsArr;
					window.headerShown = headerShownArr;
					window.boxStyleDisplay = item.tierConfig.boxStyleDisplay;
					window.boxColumnsPerRow = item.tierConfig.boxColumnsPerRow;
					window.boxActiveLayout = item.tierConfig.boxActiveLayout;


					// text alignment
					console.log("item.colGroups", item.colGroups);

					item.colGroups.forEach((colGroup) => {
						headerAsLabel.push(colGroup.headerAsLabel);
						listingLogo.push(colGroup.listingLogo == null ? false : colGroup.listingLogo);
						switch (colGroup.textAlign) {
						case 0:
							textAlign.push('left');
							break;
						case 1:
							textAlign.push('center');
							break;
						case 2:
							textAlign.push('right');
							break;
						default:
							textAlign.push('center');
							break;
						}
					});

					this.setState({
						textAlign:     textAlign,
						headerAsLabel: headerAsLabel,
						listingLogo:   listingLogo
					});
					this.props.handleHeaderAsLabel(headerAsLabel);
					this.context.setCurrentDetailAction(item.tierConfig.touchAction);
				}

				if (item.listings.length > 0) {
					this.getTierData(item.listings, listName, true);
				}
			});
		}
	}

	formatTime(i) {
		if (i < 10) {
			i = `0${i}`;
		}
		return i;
	}

	getTime() {
		let now = new Date();
		let h = now.getHours();
		let m = now.getMinutes();
		let s = now.getSeconds();

		h = this.formatTime(h);
		m = this.formatTime(m);
		s = this.formatTime(s);

		let time = `${h}:${m}:${s}`;
		if (time.length === 7) {
			time = '0' + time;
		}
		return time;
	}

	setCurrentListings = (listName, cb, { preserveAutoFlip = false } = {}) => {
		let etlData = this.props.defaultList.listings;
		window.listingsShown = [];
		this.context.setCurrentDetailAction(0);

		// add sortedVals
		this.getTierData(etlData, listName);

		const firstListing = window.listingsShown[0];
		let paginationEnabled = false;
		let paginationTimer = 5;
		if (firstListing && firstListing.length > 2) {
			const listShownConfigData = firstListing[firstListing.length - 3];
			if (listShownConfigData) {
				paginationEnabled = !!listShownConfigData.listingPagination;
				paginationTimer = listShownConfigData.paginationTimer || 5;
			}
		}

		// Check for child tier pagination settings if not found in firstListing
		if (!paginationEnabled || !paginationTimer) {
			for (let i = 0; i < window.listingsShown.length; i++) {
				const listing = window.listingsShown[i];
				if (listing && listing.length > 2) {
					const configData = listing[listing.length - 3];
					if (configData && configData.listingPagination) {
						paginationEnabled = true;
						paginationTimer = configData.paginationTimer || 5;
						break;
					}
				}
			}
		}

		// window.listingsShown is derived from props.defaultList.listings, which
		// is already gate-aware filtered upstream by ListingsScroller.
		let currentListings = [...window.listingsShown];

		const listingsShownDirs = window.listingsShownDirs;

		currentListings.sort((a, b) => {
			return sortListingsByCols(a, b, listingsShownDirs);
		});

		// React 19 fix: Create new arrays instead of mutating to ensure proper state updates
		// Remove sortedVals so details will render properly
		currentListings = currentListings.map((listing) => {
			return listing.slice(0, -1);
		});

		this.setState({
			currentListings:     currentListings,
			boxStyleDisplay:     window.boxStyleDisplay,
			boxColumnsPerRow:    window.boxColumnsPerRow,
			boxActiveLayout:     window.boxActiveLayout,
			paginationEnabled:   paginationEnabled,
			paginationTimer:     paginationTimer,
			autoFlipEnabled:     (paginationEnabled && paginationTimer > 0), // autoFlipEnabled false if timer is 0
			autoFlipInterval:    paginationTimer ? (paginationTimer * 1000) : 5000 // Convert seconds to milliseconds
		}, () => {
			if (typeof cb === 'function') {
				cb();
			}
			// Start auto-flip if enabled and not searching or ADA.
			// preserveAutoFlip skips the manual restart when the call is a passive
			// data refresh (e.g. ListingsScroller's 15-min scheduling tick) and
			// autoflip is already running — avoids resetting the user's flip clock.
			const autoFlipAlreadyRunning = !!this.paginationTimer;
			if (this.state.paginationEnabled && this.state.autoFlipEnabled && this.state.searchInputValue === '' && !this.props.navProps.adaActive && !(preserveAutoFlip && autoFlipAlreadyRunning)) {
				this.startAutoFlip(true);
			}
		});

		this.props.handleBoxData(window.boxStyleDisplay, window.boxColumnsPerRow, window.boxActiveLayout);
	}

	initializeListings = () => {
		this.setAdaTransitions();

		this.setState({
			details: false
		});
	}

	setAdaTransitions = () => {
		// allows React Transition Group to run first, then set transition
		if (this.props.weakProcessor === false) {
			setTimeout(() => {
				this.setState({
					transitions: true
				});
			}, 1000);
		}
	}

	getSearchAtScaleSetting = () => {
		let searchAtScaleSetting = '';
		let searchAtScale = false;

		for (const [m1Key, m1Data] of Object.entries(window.flatData)) {
			if (m1Key.startsWith('setting.')) {
				if (m1Data.name === 'search_at_scale') {
					searchAtScaleSetting = m1Key;
					break;
				}
			}
		};

		searchAtScale = window.flatData[`component.${this.props.component_name}`][searchAtScaleSetting]?.bool;

		return searchAtScale;
	}

	calculateDynamicItemsPerPage = () => {
		if (!this.scrollWindow || !this.scrollWindow.current) {
			return 10; 
		}

		const container = this.scrollWindow.current;
		const containerHeight = container.clientHeight;
		
		const listingsHeader = container.querySelector('.listingsHeader');
		let headerHeight = 0;
		if (listingsHeader) {
			headerHeight = listingsHeader.getBoundingClientRect().height;
		}
		
		const paginationControls = container.querySelector('.paginationControls');
		let paginationControlsHeight = 0;
		if (paginationControls) {
			paginationControlsHeight = paginationControls.getBoundingClientRect().height;
		} else if (this.state.paginationEnabled) {
			paginationControlsHeight = 60;
		}
		
		const dataRows = container.querySelectorAll('.listingRow, [class*="listingRow"]:not(.listingsHeader)');
		if (!dataRows || dataRows.length === 0) {
			return 10;
		}

		const rowHeights = [];
		const maxRowsToMeasure = Math.min(dataRows.length, 20);
		
		for (let i = 0; i < maxRowsToMeasure; i++) {
			const rowHeight = dataRows[i].getBoundingClientRect().height;
			if (rowHeight > 0) {
				rowHeights.push(rowHeight);
			}
		}
		
		if (rowHeights.length === 0) {
			return 10; 
		}
		
		rowHeights.sort((a, b) => a - b);
		
		const percentile90Index = Math.floor(rowHeights.length * 0.9);
		const safeRowHeight = rowHeights[percentile90Index] || rowHeights[rowHeights.length - 1];
		
		const margin = 20;
		const availableHeight = containerHeight - headerHeight - paginationControlsHeight - margin;
		const calculatedItems = Math.floor(availableHeight / safeRowHeight);
		
		const finalItems = Math.max(1, Math.min(calculatedItems, 100));
		
		return finalItems;
	}

	validatePageFit = () => {
		if (!this.scrollWindow || !this.scrollWindow.current || !this.state.paginationEnabled) {
			return true;
		}

		const container = this.scrollWindow.current;
		const containerHeight = container.clientHeight;
		
		const listingsContent = container.querySelector('.listings-content-container');
		if (!listingsContent) {
			return true;
		}
		
		const contentHeight = listingsContent.getBoundingClientRect().height;
		const paginationControls = container.querySelector('.paginationControls');
		const paginationHeight = paginationControls ? paginationControls.getBoundingClientRect().height : 0;
		
		const totalUsedHeight = contentHeight + paginationHeight + 20;
		
		return totalUsedHeight <= containerHeight;
	}

	adjustPageSizeForFit = () => {
		if (!this.state.paginationEnabled || this.props.navProps.adaActive) {
			return;
		}
		
		setTimeout(() => {
			if (!this.validatePageFit()) {
				const newItemsPerPage = Math.max(1, this.state.calculatedItemsPerPage - 1);
				
				if (newItemsPerPage !== this.state.calculatedItemsPerPage) {
					this.setState({ 
						calculatedItemsPerPage: newItemsPerPage 
					});
				}
			}
		}, 100);
	}

	updateCalculatedItemsPerPage = () => {
		if (this.state.paginationEnabled && this.state.searchInputValue === '') {
			if (this.recalculateTimeout) {
				clearTimeout(this.recalculateTimeout);
			}
			
			this.recalculateTimeout = setTimeout(() => {
				const newCalculatedItems = this.calculateDynamicItemsPerPage();
				
				if (newCalculatedItems !== this.state.calculatedItemsPerPage) {
					this.setState({ 
						calculatedItemsPerPage: newCalculatedItems,
						currentPage: 0
					}, () => {
						if (this.state.autoFlipEnabled && !this.paginationTimer && !this.props.navProps.adaActive) {
							this.startAutoFlip(true);
						}
						setTimeout(() => {
							if (!this.props.navProps.adaActive) {
								this.setPaginationVisibility(true);
							}
						}, 100);
					});
				} else {
					if ((!this.state.paginationControlsVisible || !this.state.listingsVisible) && !this.props.navProps.adaActive) {
						setTimeout(() => {
							this.setPaginationVisibility(true);
						}, 100);
					}
				}
			}, 250);
		}
	}

	initializePaginationSettings = () => {
		let paginationEnabled = this.state.paginationEnabled;

		if (!paginationEnabled) {
			this.setState({
				paginationEnabled: false,
				autoFlipEnabled: false,
				autoFlipInterval: 5000,
				paginationInitialized: true
			});
			this.setPaginationVisibility(true); // Show listings immediately when pagination is disabled
			return;
		}
			
		const autoFlipEnabled = true; 
		const autoFlipInterval = this.state.autoFlipInterval;

		this.setState({
			paginationEnabled,
			autoFlipEnabled,
			autoFlipInterval: autoFlipInterval,
			paginationInitialized: true
		}, () => {
			// Start hidden, will fade in after calculations, unless ADA is active
			this.setPaginationVisibility(!this.props.navProps.adaActive); 
			
			if (this.state.paginationEnabled && typeof ResizeObserver !== 'undefined' && this.scrollWindow && this.scrollWindow.current) {
				this.dynamicPaginationObserver = new ResizeObserver(() => {
					this.updateCalculatedItemsPerPage();
				});
				this.dynamicPaginationObserver.observe(this.scrollWindow.current);
			}

			if (this.state.paginationEnabled) {
				setTimeout(() => {
					this.updateCalculatedItemsPerPage();
					if (this.state.autoFlipEnabled && !this.props.navProps.adaActive) {
						this.startAutoFlip(true);
					}
				}, 100);
			}
		});
	}

	getCurrentListingsForPagination = () => {
		const isSearching = this.state.searchInputValue !== '';
		return isSearching ? 
			this.state.filteredListings.reduce((acc, cat) => [...acc, ...cat.listings], []) : 
			this.state.currentListings;
	}

	shouldShowPagination = () => {
		return this.state.paginationInitialized && 
			   this.state.paginationEnabled && 
			   this.state.searchInputValue === '' && 
			   !this.props.navProps.adaActive && 
			   (!this.props.tieredDetails || this.props.tieredDetails.length === 0);
	}

	setPaginationVisibility = (isVisible, callback = null) => {
		this.setState({
			paginationControlsVisible: isVisible,
			listingsVisible: isVisible || !this.state.paginationEnabled || 
							 this.state.searchInputValue !== '' || 
							 this.props.navProps.adaActive
		}, callback);
	}

	calculateTotalPages = (listings) => {
		if (!this.state.paginationEnabled || !listings || listings.length === 0) {
			return 1;
		}
		
		const effectiveItemsPerPage = this.state.calculatedItemsPerPage;
			
		if (effectiveItemsPerPage <= 0) {
			return 1;
		}
		
		return Math.ceil(listings.length / effectiveItemsPerPage);
	}

	getCurrentPageItems = (listings) => {
		if (!this.state.paginationEnabled || !listings || listings.length === 0 || this.props.navProps.adaActive) {
			return listings || [];
		}

		let effectiveItemsPerPage = this.state.calculatedItemsPerPage;
		const startIndex = this.state.currentPage * effectiveItemsPerPage;
		
		let pageItems = listings.slice(startIndex, startIndex + effectiveItemsPerPage);
		
		return pageItems;
	}

	nextPage = () => {
		const currentListings = this.getCurrentListingsForPagination();
		const totalPages = this.calculateTotalPages(currentListings);

		if (totalPages <= 1) return;

		this.setState(
			prevState => {
				return { currentPage: (prevState.currentPage + 1) % totalPages };
			},
			() => {
				// Only restart autoFlip if enabled, not paused, and page actually changed
				if (
					this.state.paginationEnabled &&
					this.state.autoFlipEnabled &&
					!this.props.navProps.adaActive &&
					!this.userPausedAutoFlip
				) {
					this.startAutoFlip(true);
				}
			}
		);
	}

	prevPage = () => {
		const currentListings = this.getCurrentListingsForPagination();
		const totalPages = this.calculateTotalPages(currentListings);
		
		if (totalPages <= 1) return;
		
		this.setState(prevState => ({
			currentPage: prevState.currentPage === 0 ? totalPages - 1 : prevState.currentPage - 1
		}));
	}

	startAutoFlip = (isManualStart = false) => {
		if (this.state.paginationEnabled && this.state.autoFlipEnabled && !this.props.navProps.adaActive) {
			const currentListings = this.getCurrentListingsForPagination();
			const totalPages = this.calculateTotalPages(currentListings);
			
			if (totalPages <= 1) {
				return;
			}
			
		
			if (isManualStart) {
				this.stopAutoFlip();
			} else {
				if (this.paginationTimer) {
					clearTimeout(this.paginationTimer);
					this.paginationTimer = null;
				}
				if (this.progressTimer) {
					clearInterval(this.progressTimer);
					this.progressTimer = null;
				}
			}
			
			// Record start time
			this.autoFlipStartTime = Date.now();
			
			// Set up the pagination timer
			this.paginationTimer = setTimeout(() => {
				this.nextPage();
				this.startAutoFlip(false); // Pass false to indicate automatic restart
			}, this.state.autoFlipInterval);
			
			this.progressTimer = setInterval(() => {
				const elapsed = Date.now() - this.autoFlipStartTime;
				const timeRemaining = Math.max(0, this.state.autoFlipInterval - elapsed);
				const progress = Math.min(100, (elapsed / this.state.autoFlipInterval) * 100);
				
				this.setState({
					autoFlipProgress: progress,
					autoFlipTimeRemaining: timeRemaining
				});
				
				// Clear interval when timer is complete
				if (timeRemaining <= 0) {
					clearInterval(this.progressTimer);
					this.progressTimer = null;
				}
			}, 100);
		}
	}

	stopAutoFlip = () => {
		if (this.paginationTimer) {
			clearTimeout(this.paginationTimer);
			this.paginationTimer = null;
		}
		if (this.progressTimer) {
			clearInterval(this.progressTimer);
			this.progressTimer = null;
		}
		
		this.setState({
			autoFlipProgress: 0,
			autoFlipTimeRemaining: 0
		});
	}

	createRows = () => {
		let rows = [];
		let css = this.state.css;
		let numberOfResults = 0;

		let searchAtScale = this.getSearchAtScaleSetting();
		let searchAtScaleInstructions = '';

		for (const [m1Key, m1Data] of Object.entries(window.flatData)) {
			if (m1Key.startsWith('setting.')) {
				if (m1Data.name === 'search_at_scale_instructions') {
					searchAtScaleInstructions = m1Key;
					break;
				}
			}
		};

		if (searchAtScale && this.state.currentListings.length > 100) {
			let containerStyles = {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100%',
				fontStyle: 'italic'
			};

			return (
				<div style={containerStyles} className='searchAtScaleContainer'>
					{window.flatData[`component.${this.props.component_name}`][searchAtScaleInstructions]?.string || 'Type to search.'}
				</div>
			)
		}

		// For translation
		const {t} = this.props;

		// Get current page items for pagination
		const displayListings = this.getCurrentPageItems(this.state.currentListings);

		if (!this.state.boxStyleDisplay) {
			rows.push(
				<div className={`listingsHeader ${css.header}`} key='listingsHeaderLine'>
					<ListingHeader
						{...this.props}
						key={'test'}
						data={this.state.currentHeader}
						css={this.state.columnWidths}
						textAlign={this.state.textAlign}
						currentDetailAction={this.context.currentDetailAction}
						listings
					/>
				</div>
			);
		}
		let boxStyleDetails;
		displayListings.forEach((row, i) => {
			let rowUUID = row[0];
			let touchAction = row[1];
			let listingTier = row[row.length - 2]?.listingTier || 0;
			boxStyleDetails = row[row.length - 2]

			let listingsWithoutUUID = row.slice(2);
			let detailsGrp = listingsWithoutUUID.pop();

			if (numberOfResults < 500) {
				numberOfResults++;
				//special handling for Tier+1
				let addToHistory = this.props.addToHistory;
				if (touchAction !== 10) {
					addToHistory = null;
				}

				const { defaultList, ...propsWithoutDefaultList } = this.props;

				rows.push(
					<ListingRow
						{...propsWithoutDefaultList}
						key={`row_${i}`}
						data={listingsWithoutUUID}
						headerData={this.state.currentHeader}
						detailsGrp={detailsGrp}
						css={this.state.columnWidths}
						currentDetailAction={touchAction}
						rowUUID={rowUUID}
						boxStyleDisplay={boxStyleDetails?.boxStyleDisplay}
						boxColumnsPerRow={boxStyleDetails?.boxColumnsPerRow + 1}
						boxActiveLayout={boxStyleDetails?.boxActiveLayout + 1}
						setDetailsData={this.props.setDetailsData}
						detailsTitle={this.props.details[0]}
						setDetailsTitle={this.props.setDetailsTitle}
						textAlign={this.state.textAlign}
						listingLogo={this.state.listingLogo}
						headerAsLabel={this.state.headerAsLabel}
						addToHistory={addToHistory}
						displayChildTier={this.props.displayChildTier}
						messageLabels={this.props.messageLabels}
						num={i}
						listingTier={listingTier}
						openWayfindingModal={this.openWayfindingModal}
					/>
				);
			}
		});

		if (numberOfResults >= 500) {
			rows.unshift(<p className={`listingsOverlimit ${css.overLimit}`}>{t('listingsTooManyResultsError')}</p>);
		}

		if (boxStyleDetails?.boxStyleDisplay) {
			rows = (
				<div className={`${css.boxContainer} listingsBoxContainer`}>
					{rows}
				</div>
			);
		}

		return (
			rows
		);
	}

	createFilteredRows = () => {
		let css = this.state.css;
		let filteredListings = this.state.filteredListings;
		let searchAtScale = this.getSearchAtScaleSetting();

		let searchAtScaleTooManyResults = '';

		for (const [m1Key, m1Data] of Object.entries(window.flatData)) {
			if (m1Key.startsWith('setting.')) {
				if (m1Data.name === 'search_at_scale_too_many_results') {
					searchAtScaleTooManyResults = m1Key;
					break;
				}
			}
		};


		if (searchAtScale) {
			let containerStyles = {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100%',
				fontStyle: 'italic'
			};

			let totalNumberOfListings = 0;

			filteredListings.forEach((category, i) => {
				totalNumberOfListings += category.listings.length	
			})

			if (totalNumberOfListings > 100 * filteredListings.length) {
				return (
					<div style={containerStyles} className='searchAtScaleContainer'>
						{totalNumberOfListings} {window.flatData[`component.${this.props.component_name}`][searchAtScaleTooManyResults]?.string || 'results found. Keep typing to narrow down your search.'}
					</div>
				)
			}
		}

		// For translation
		const {t} = this.props;
	
		filteredListings.forEach((category, i) => {
			if (!filteredListings[i].listings) {
				filteredListings[i].listings = [];
			}
			if (!filteredListings[i].secondaryListings) {
				filteredListings[i].secondaryListings = [];
			}
		});
	
		let numberOfResults = 0;
		let primaryCategoryRowsMap = {};
		let secondaryCategoryRowsMap = {};
	
		// First pass: Render all PRIMARY results across all tiers
		filteredListings.forEach((category, i) => {
			let categoryRows = [];
			let categoryBoxStyleDetails = {};
			const primaryLen = category.listings.length;

			// Render primary results if any exist
			if (primaryLen > 0) {
				if (numberOfResults < 500) {
					let textAlign = [];
					const styleSourceRow = category.listings[0];
					if (styleSourceRow) {
						categoryBoxStyleDetails.boxStyleDisplay = styleSourceRow[styleSourceRow.length - 2]?.boxStyleDisplay;
						categoryBoxStyleDetails.boxColumnsPerRow = styleSourceRow[styleSourceRow.length - 2]?.boxColumnsPerRow;
					}

					category.category.textAlign.forEach((alignment) => {
						switch (alignment) {
						case 0:
							textAlign.push('left');
							break;
						case 1:
							textAlign.push('center');
							break;
						case 2:
							textAlign.push('right');
							break;
						default:
							textAlign.push('center');
							break;
						}
					});
	
					if (!categoryBoxStyleDetails.boxStyleDisplay) {
						categoryRows.push(
							<div className={`listingsHeader ${css.header}`} key={`header_${i}`}>
								<ListingHeader
									{...this.props}
									data={category.category.headersShown}
									css={category.category.headersWidths}
									textAlign={this.state.textAlign}
									currentDetailAction={this.context.currentDetailAction}
								/>
							</div>
						);
					} else {
						let boxHeaderArr = [category.category.category];
						categoryRows.push(
							<div className={`listingsHeader ${css.header}`} key={`box_header_${i}`}>
								<ListingHeader
									{...this.props}
									data={boxHeaderArr}
									css={this.state.columnWidths}
									textAlign={this.state.textAlign}
									currentDetailAction={this.context.currentDetailAction}
								/>
							</div>
						);
					}
				}
	
				// Render PRIMARY results
				category.listings.forEach((row, j) => {
					if (numberOfResults < 500) {
						let rowUUID = row[0];
						let listingsWithoutUUID = row.slice(1);
						let detailsGrp = listingsWithoutUUID.pop();
						let boxActiveLayout = row[row.length - 2]?.boxActiveLayout
						let textAlign = [];
						category.category.textAlign.forEach((alignment) => {
							switch (alignment) {
								case 0:
									textAlign.push('left');
									break;
								case 1:
									textAlign.push('center');
									break;
								case 2:
									textAlign.push('right');
									break;
								default:
									textAlign.push('center');
									break;
							}
						});
	
					numberOfResults++;

					const { defaultList, ...propsWithoutDefaultList } = this.props;
					categoryRows.push(
						<ListingRow
							{...propsWithoutDefaultList}
							key={`filtered_row_${i}_${j}`}
							data={listingsWithoutUUID}
							detailsGrp={detailsGrp}
							css={category.category.headersWidths}
							currentDetailAction={category.category.detailAction}
							headerData={category.category.headersShown}
							headerAsLabel={category.category.headerAsLabel}
							rowUUID={rowUUID}
							boxStyleDisplay={categoryBoxStyleDetails.boxStyleDisplay}
							boxColumnsPerRow={categoryBoxStyleDetails.boxColumnsPerRow + 1}
							boxActiveLayout={boxActiveLayout + 1}
							setDetailsData={this.props.setDetailsData}
							detailsTitle={this.props.details[0]}
							setDetailsTitle={this.props.setDetailsTitle}
							textAlign={textAlign}
							displayChildTier={this.props.displayChildTier}
							messageLabels={this.props.messageLabels}
							num={j}
							searchInputValue={this.state.searchInputValue}
							tier={i + 1}
							openWayfindingModal={this.openWayfindingModal}
						/>
					);
				}
			});

				if (categoryBoxStyleDetails.boxStyleDisplay) {
					if (categoryRows.length > 0) {
						categoryRows = (
							<div className={`${css.boxContainer} listingsBoxContainer`} key={`box_container_${i}`}>
								{categoryRows}
							</div>
						);
					}
				}

				if (categoryRows.length > 0 || React.isValidElement(categoryRows)) {
					primaryCategoryRowsMap[i] = categoryRows;
				}
			}
		});

		// Second pass: Render all SECONDARY results across all tiers
		let hasSecondaryResults = false;
		filteredListings.forEach((category, i) => {
			let categoryRows = [];
			let categoryBoxStyleDetails = {};
			const secondaryLen = (category.secondaryListings || []).length;

			// Render secondary results if any exist
			if (secondaryLen > 0 && numberOfResults < 500 && this.state.searchInputValue !== '') {
				hasSecondaryResults = true;

				let textAlign = [];
				const styleSourceRow = category.secondaryListings[0];
				if (styleSourceRow) {
					categoryBoxStyleDetails.boxStyleDisplay = styleSourceRow[styleSourceRow.length - 2]?.boxStyleDisplay;
					categoryBoxStyleDetails.boxColumnsPerRow = styleSourceRow[styleSourceRow.length - 2]?.boxColumnsPerRow;
				}

				category.category.textAlign.forEach((alignment) => {
					switch (alignment) {
						case 0:
							textAlign.push('left');
							break;
						case 1:
							textAlign.push('center');
							break;
						case 2:
							textAlign.push('right');
							break;
						default:
							textAlign.push('center');
							break;
					}
				});

				// Add header for secondary tier results
				if (!categoryBoxStyleDetails.boxStyleDisplay) {
					categoryRows.push(
						<div className={`listingsHeader ${css.header}`} key={`header_secondary_${i}`}>
							<ListingHeader
								{...this.props}
								data={category.category.headersShown}
								css={category.category.headersWidths}
								textAlign={this.state.textAlign}
							/>
						</div>
					);
				} else {
					let boxHeaderArr = [category.category.category];
					categoryRows.push(
						<div className={`listingsHeader ${css.header}`} key={`box_header_secondary_${i}`}>
							<ListingHeader
								{...this.props}
								data={boxHeaderArr}
								css={this.state.columnWidths}
								textAlign={this.state.textAlign}
							/>
						</div>
					);
				}

				category.secondaryListings.forEach((row, sj) => {
					if (numberOfResults < 500) {
						let rowUUID = row[0];
						let listingsWithoutUUID = row.slice(1);
						let detailsGrp = listingsWithoutUUID.pop();
						let boxActiveLayout = row[row.length - 2]?.boxActiveLayout
						let textAlign = [];
						category.category.textAlign.forEach((alignment) => {
							switch (alignment) {
							case 0:
								textAlign.push('left');
								break;
							case 1:
								textAlign.push('center');
								break;
							case 2:
								textAlign.push('right');
								break;
							default:
								textAlign.push('center');
								break;
							}
						});

						numberOfResults++;

						const { defaultList, ...propsWithoutDefaultList } = this.props;
						categoryRows.push(
							<ListingRow
								{...propsWithoutDefaultList}
								key={`filtered_row_secondary_${i}_${sj}`}
								data={listingsWithoutUUID}
								detailsGrp={detailsGrp}
								css={category.category.headersWidths}
								currentDetailAction={category.category.detailAction}
								headerData={category.category.headersShown}
								headerAsLabel={category.category.headerAsLabel}
								rowUUID={rowUUID}
								boxStyleDisplay={categoryBoxStyleDetails.boxStyleDisplay}
								boxColumnsPerRow={categoryBoxStyleDetails.boxColumnsPerRow + 1}
								boxActiveLayout={boxActiveLayout + 1}
								setDetailsData={this.props.setDetailsData}
								detailsTitle={this.props.details[0]}
								setDetailsTitle={this.props.setDetailsTitle}
								textAlign={textAlign}
								displayChildTier={this.props.displayChildTier}
								messageLabels={this.props.messageLabels}
								num={sj}
								searchInputValue={this.state.searchInputValue}
								tier={i + 1}
								openWayfindingModal={this.openWayfindingModal}
							/>
						);
					}
				});

				if (categoryBoxStyleDetails.boxStyleDisplay) {
					if (categoryRows.length > 0) {
						categoryRows = (
							<div className={`${css.boxContainer} listingsBoxContainer`} key={`box_container_secondary_${i}`}>
								{categoryRows}
							</div>
						);
					}
				}

				if (categoryRows.length > 0 || React.isValidElement(categoryRows)) {
					secondaryCategoryRowsMap[i] = categoryRows;
				}
			}
		});
	
		// Merge primary and secondary results with separator header
		let mergedRows = [];
		
		// Add all primary results first
		Object.keys(primaryCategoryRowsMap).forEach((category) => {
			mergedRows = mergedRows.concat(primaryCategoryRowsMap[category]);
		});
		
		// Add secondary search header if we have secondary results
		if (hasSecondaryResults && this.state.searchInputValue !== '') {
			const totalPrimaryResults = Object.keys(primaryCategoryRowsMap).length;
			const secondaryHeaderText = totalPrimaryResults === 0
				? 'There are no primary search results. Showing only advanced search results'
				: 'Advanced Search Results';
			mergedRows.push(
				<div className={`secondarySearchHeader ${css.secondarySearchHeader}`} key={`advanced_search_separator`}>
					<FontAwesomeIcon icon={faSearch} className={`secondarySearchIcon ${css.secondarySearchIcon}`} />
					<div className={'secondarySearchText'}>{secondaryHeaderText}</div>
				</div>
			);
		}
		
		// Add all secondary results
		Object.keys(secondaryCategoryRowsMap).forEach((category) => {
			mergedRows = mergedRows.concat(secondaryCategoryRowsMap[category]);
		});
	
		if (mergedRows.length === 0) {
			mergedRows.push(
				<div className={`listingsNoMatchingResults ${css.noMatchingResults}`} key={`key_no_results`}>
					No matching results found
				</div>
			);
		}
	
		if (numberOfResults >= 500) {
			mergedRows.unshift(
				<p className={`listingsOverLimit ${css.overLimit}`} key={`key_over_limit`}>
					{t('listingsTooManyResultsError')}
				</p>
			);
		}

		return (
			mergedRows
		);
	}

	buildContent = () => {
		const shouldShowListings = this.state.listingsVisible || 
									!this.state.paginationEnabled || 
									this.state.searchInputValue !== '' ||
									this.props.navProps.adaActive;
		
		const listingsTransitionStyle = {
			opacity: shouldShowListings ? 1 : 0,
			transition: 'opacity 0.3s ease-in-out',
			visibility: shouldShowListings ? 'visible' : 'hidden'
		};

		return (
			<CSSTransition
				in={this.state.detailsPage === false}
				appear={this.state.detailsPage === false}
				timeout={1000}
				unmountOnExit
				classNames='contentFade'
				nodeRef={this.listingsContainerRef}>
				<div
					ref={this.listingsContainerRef}
					className="listings-content-container"
					style={listingsTransitionStyle}
				>
					{this.state.searchInputValue === '' ? this.createRows() : this.createFilteredRows()}
				</div>
			</CSSTransition>
		);
	}

	handleListingsScroll = () => {
		 // Clear the previous timer, if it exists
		 if (this.scrollTimeout) {
			clearTimeout(this.scrollTimeout);
		}

		// Set scrolling state to true
		this.setState({isScrolling: true});

		// Set a timer to detect when scrolling stops
		this.scrollTimeout = setTimeout(() => {
			this.setState({isScrolling: false});
			// This is where you can trigger your desired action
			console.log('Scrolling has stopped!');
			this.props.navEvents('idleTimer', '||| Listings.js > handleListingsScroll()');
		}, 150); // 150ms delay, you can adjust this value

	}

	closeDetailsPage = () => {
		this.setState({
			detailsPage: false
		});
	}

	setSearchInputValue = (value) => {
		this.setState({searchInputValue: value});
		this.props.setSearchValue(value);
		if (value === '') {
			this.setState({filteredListings: []});
			return;
		}
		this.searchListings(value);
	}

	clearSearch = () => {
		this.setSearchInputValue('');
		if (this.keyboardComponent.current && this.keyboardComponent.current.keyboard) {
			this.keyboardComponent.current.keyboard.setInput('');
		}
		this.props.navEvents('idleTimer', '||| Listings.js > clearSearch()');
	}

	createPaginationControls = () => {
		if (!this.shouldShowPagination()) {
			return null;
		}

		const css = this.state.css;
		const currentListings = this.getCurrentListingsForPagination();
		const totalPages = this.calculateTotalPages(currentListings);

		const currentPage = this.state.currentPage + 1;
		const isAutoFlipping = !!this.paginationTimer;

		const transitionStyle = {
			opacity: this.state.paginationControlsVisible ? 1 : 0,
			transition: 'opacity 0.3s ease-in-out',
			visibility: this.state.paginationControlsVisible ? 'visible' : 'hidden'
		};

		return (
			<div 
				className={`${css.paginationControls || ''} paginationControls`}
				style={transitionStyle}
			>
				{this.state.autoFlipEnabled && (
					<div className={`${css.paginationProgressContainer || ''} paginationProgressContainer`}>
						<div 
							className={`${css.paginationProgressBar || ''} paginationProgressBar`}
							style={{
								width: isAutoFlipping ? `${this.state.autoFlipProgress}%` : '0%',
								transition: 'width 0.1s ease-out',
							}}
						></div>
						<div 
							className={`${css.paginationProgressBackground || ''} paginationProgressBackground`}
							style={{
								position: 'absolute',
								top: 0,
								left: 0,
								right: 0,
								zIndex: -1
							}}
						></div>
					</div>
				)}
				
				<div className={`${css.paginationButtons || ''} paginationButtons`}>
					<button 
						className={`${css.paginationBtn || ''} paginationBtn paginationPrevBtn`}
						onClick={(e) => {
							e.stopPropagation();
							this.prevPage();
						}}
						onPointerDown={(e) => e.stopPropagation()}
						disabled={totalPages <= 1}
					>
						<FontAwesomeIcon icon={faArrowLeft} className={`${css.paginationIcon} ${css.paginationPrevIcon} paginationIcon paginationPrevIcon`} />
					</button>
					
					<span className={`${css.paginationInfo || ''} paginationInfo`}>
						Page {currentPage} of {totalPages}
						{this.state.autoFlipEnabled && (isAutoFlipping || this.state.autoFlipTimeRemaining > 0) && !this.userPausedAutoFlip && (
							<span className={`${css.paginationTimeRemaining || ''} paginationTimeRemaining`}>
								{' '}({Math.ceil(Math.max(1, this.state.autoFlipTimeRemaining / 1000))}s)
							</span>
						)}
					</span>
					
					<button 
						className={`${css.paginationBtn || ''} paginationBtn paginationNextBtn`}
						onClick={(e) => {
							e.stopPropagation();
							this.nextPage();
						}}
						onPointerDown={(e) => e.stopPropagation()}
						disabled={totalPages <= 1}
					>
						<FontAwesomeIcon icon={faArrowRight} className={`${css.paginationIcon} ${css.paginationNextIcon} paginationIcon paginationNextIcon`} />
					</button>
					
					{this.state.autoFlipEnabled && (
						<button 
							className={`${css.paginationBtn || ''} paginationBtn paginationAutoBtn`}
							onClick={(e) => {
								e.stopPropagation();
								if (isAutoFlipping) {
									this.stopAutoFlip();
									this.userPausedAutoFlip = true;
								} else {
									this.startAutoFlip(true);
									this.userPausedAutoFlip = false;
								}
							}}
							onPointerDown={(e) => e.stopPropagation()}
							disabled={totalPages <= 1}
						>
							{isAutoFlipping ? <FontAwesomeIcon icon={faPause} className={`${css.paginationIcon} ${css.paginationAutoPauseIcon} paginationIcon paginationAutoPauseIcon`} /> : <FontAwesomeIcon icon={faPlay} className={`${css.paginationIcon} ${css.paginationAutoPlayIcon} paginationIcon paginationAutoPlayIcon`} /> }
						</button>
					)}
				</div>
			</div>
		);
	}

	searchListings = (value) => {
		let filteredListings = [];
		window.completeListings.forEach((category, i) => {
			filteredListings.push({category: category, listings: [], secondaryListings: []});

			const sortValues = makeSortKeyIndices(category.sortValues);
			const sortedDirs = makeSortedDirsForIndices(sortValues, category.sortDirections);

			// add sortedVals
			category.listings = category.listings.map((listing) => {
				const sortedVals = [listing.rank || 0];

				for (let sortIndex of sortValues) {
					sortedVals.push(listing[sortIndex].value);
				}
				listing.push(sortedVals);

				return listing;
			});

			// sort by sortedVals
			category.listings.sort((a, b) => {
				return sortListingsByCols(a, b, sortedDirs);
			});

			// React 19 fix: Create new arrays instead of mutating
			// Remove sortedVals
			category.listings = category.listings.map((listing) => {
				return listing.slice(0, -1);
			});

			category.listings.forEach((listingRow) => {
				const match = matchListingRow(listingRow, value);

				if (match === 'primary' && filteredListings[i].listings[filteredListings[i].listings.length - 1] !== listingRow) {
					filteredListings[i].listings.push(listingRow);
				} else if (match === 'secondary' && filteredListings[i].secondaryListings[filteredListings[i].secondaryListings.length - 1] !== listingRow) {
					filteredListings[i].secondaryListings.push(listingRow);
				}
			});
		});
		this.setState({filteredListings});
	}

	getCompleteListings = (listings, listName) => {
		if (Array.isArray(listings) && listings.length > 0) {
			listings.forEach((item) => {
				if (item.colGroups[0] && item.colGroups[0].dataName === listName) {
					let row = [];
					let headerWidths = [];
					let headerShown = [];
					let textAlign = [];
					let headerAsLabel = [];
					let sortValues = [];
					let sortDirections = [];
					let detailAction = item.tierConfig.touchAction;

					// listings
					row.push(...buildSearchCells(item));

					// header & text
					item.colGroups.forEach((headerData) => {
						headerWidths.push(headerData.width);
						headerShown.push(headerData.name);
						textAlign.push(headerData.textAlign);
						headerAsLabel.push(headerData.headerAsLabel);
						sortValues.push(headerData.sort);
						sortDirections.push(headerData.sort_direction);
					});

					window.completeListings.forEach((category) => {
						if (category.category !== listName) {
							return;
						}

						category.listings.push([item.m1Key, ...row, item.tierConfig, item.detailsGrp]);
						category.headersWidths = headerWidths;
						category.headersShown = headerShown;
						category.textAlign = textAlign;
						category.headerAsLabel = headerAsLabel;
						category.detailAction = detailAction;
						category.sortValues = sortValues;
						category.sortDirections = sortDirections;
					});
				}

				if (item.listings.length > 0) {
					this.getCompleteListings(item.listings, listName);
				}
			});
		}
	}


	render() {
		let css = this.state.css;
		let adaClass = '';
		let cssTransition = '';
		// t function for translation.
		const {t} = this.props;
		if (this.props.navProps.adaActive === true) {
			adaClass = css.adaActive;
		}

		if (this.state.transitions === true) {
			cssTransition = css.adaTransition;
		}

		let adaTopPad = {
			paddingTop: this.state.adaTopPad
		};

		let message = '';
		let listingsScrollerMessage = '';
		if (this.context.currentDetailAction !== 0) {
			listingsScrollerMessage = css.listingsScrollerMessage;

			let messageText = t('selectListingLabel');
			if (this.context.currentDetailAction === 7 || this.context.currentDetailAction === TOUCH_ACTION_DIRECT_WAYFINDING) {
				messageText = t('selectMapListingLabel');
			}
			
			if(this.props.list_scroller_instructions && this.props.list_scroller_instructions !== ''){
				messageText = this.props.list_scroller_instructions;
			}
			
			message = <div onScroll={() => {
				return this.handleListingsScroll();
			}} className={`listingsDirectionsMessage ${css.directionsMessage}`}><div className={`${css.directionsIcon} directionsIcon`}></div>{messageText}</div>;
		}

		let scrollType = '';
		if (this.props.scrollButtons === 2) {
			scrollType = css.smoothScroll;
		}

		return (
			<CSSTransition
				in={true}
				appear={true}
				timeout={1000}
				unmountOnExit
				onEntering={this.initializeListings}
				onExited={this.closeDetailsPage}
				classNames='contentFade'
				nodeRef={this.wrapperRef}>
				<div ref={this.wrapperRef}>
					<div className={`${adaClass}`}>
						<div id="listingsMenuBarLeft" className={`listingsContentMenuBarLeft ${css.contentMenuBarLeft} ${cssTransition}`}></div>
						<div id="listingsMenuBarRight" className={`listingsContentMenuBarRight ${css.contentMenuBarRight} ${cssTransition}`}>
							<div className={`listingsKeyboardContainer ${css.keyboardContainer}`}>
								<div className={`listingsSearchInputContainer ${css.searchInputContainer}`}>
									<FontAwesomeIcon icon={faSearch} className={`listingsSearchIcon ${css.searchIcon}`} />
									<input
										type="text"
										defaultValue={this.state.searchInputValue}
										className={`listingsSearchInput ${css.searchInput}`}
										placeholder={t('searchPlaceholder')}
										onClick={(e) => {
											this.props.navEvents('idleTimer', '||| Listings.js > render()');
											this.setState({isKeyboardHidden: false});
										}}
									/>
									{this.state.searchInputValue && (
										<FontAwesomeIcon 
											icon={faTimes} 
											className={`searchClearIcon ${css.searchClearIcon}`}
											onClick={this.clearSearch}
										/>
									)}
								</div>
								<Keyboard
									ref={this.keyboardComponent}
									navEvents={this.props.navEvents}
									navProps={this.props.navProps}
									closeDetailsPage={this.props.closeDetailsPage}
									defaultKeyboard={this.props.defaultKeyboard}
									setDetailsTitle={this.props.setDetailsTitle}
									setTieredHeadersAndDetails={this.props.setTieredHeadersAndDetails}
									setHistory={this.props.setHistory}
									setInputValue={this.setSearchInputValue}
									searchUpdater={this.state.searchUpdater}
									condor_component_group={this.props.condor_component_group}
									condor_configuration={this.props.condor_configuration}
									condor_theme={this.props.condor_theme}
									CSSModules={this.props.CSSModules}
									isKeyboardHidden={this.state.isKeyboardHidden}
									hideKeyboard={() => this.setState({isKeyboardHidden: true})}
								/>
							</div>
						</div>

						<div id="secondaryNav" className={`listingsSecondaryNav ${css.secondaryNav} ${cssTransition}`}>
							{this.createButtons()}
						</div>

						<div className={`listingsListingsContainer ${css.listingsContainer} ${cssTransition} ${this.props.defaultListName.toLowerCase()} ${isWayfindingModalAction(this.context.currentDetailAction) ? `${css.listingsMapBtn} listingsMapBtn` : ''}`}>
							<CSSTransition
								in={this.props.detailsPage === false}
								appear={this.props.detailsPage === false}
								timeout={1000}
								classNames={`contentFade`}
								nodeRef={this.scrollerRef}>
								<div ref={this.scrollerRef} style={{width: '100%', height: '100%'}}>
									<div id='listingsScroller' ref={this.scrollWindow} className={`listingsListingsScroller ${css.listingsScroller} ${scrollType} ${listingsScrollerMessage} listingsTier${this.props.tierLevel ?? 0} ${this.state.paginationEnabled && this.state.searchInputValue === '' && (!this.props.tieredDetails || this.props.tieredDetails.length === 0) && !this.props.navProps.adaActive ? `  listingsScrollerPagination ${css.listingsScrollerPagination}` : ''}`} style={adaTopPad} onScroll={this.handleListingsScroll} >
										{this.props.tieredDetails.length > 0 && this.props.detailsTitle !== '' && <p className={`listingsDetailsTitle ${css.detailsTitle}`}>{this.props.detailsTitle}</p>}
										{this.props.tieredDetails.length === 0 && this.buildContent()}
										{this.props.tieredHeaders}
										{/* this is done cause state and props based boxStyleDisplay is unreliable */}
										{this.props.tieredDetails.length > 0 && this.props.tieredDetails[this.props.tieredDetails.length - 1]?.props?.boxStyleDisplay ? (
          									<div className={`${css.boxContainer} listingsBoxContainer`}>
           										{this.props.tieredDetails}
         									</div>
       									 ) : (
         									this.props.tieredDetails
       	 								)}
										{message}
										<div className={`${css.scrollBtnCont} scrollBtnCont`}>
											<div className={`${css.scrollBtn} scrollBtn`}
												onContextMenu={(e) => {
													e.preventDefault();
												}}
												onPointerDown={(e) => {
													e.preventDefault();
													this.handlePointerDown(e, 'up')
												}}
												onPointerUp={this.stopScrolling}
												onPointerLeave={this.stopScrolling}
												onPointerOut={this.stopScrolling}
												ref={this.scrollUpBtn}
											>
												<div className={`${css.scrollArrowUp} ${css.scrollArrow} scrollArrowUp scrollArrow`}></div>
												<div className={`${css.scrollBtnText} scrollBtnText`}>Scroll Up</div>
											</div>
											<div className={`${css.scrollBtn} scrollBtn`}
												onContextMenu={(e) => {
													e.preventDefault();
												}}
												onPointerDown={(e) => {
													e.preventDefault();
													this.handlePointerDown(e, 'down')
												}}
												onPointerUp={this.stopScrolling}
												onPointerLeave={this.stopScrolling}
												onPointerOut={this.stopScrolling}
												ref={this.scrollDownBtn}
											>
												<div className={`${css.scrollArrowDown} ${css.scrollArrow} scrollArrowDown scrollArrow`}></div>
												<div className={`${css.scrollBtnText} scrollBtnText`}>Scroll Down</div>
											</div>
										</div>
										{this.createPaginationControls()}
									</div>
								</div>
							</CSSTransition>
						</div>

					</div>

					<div>
						{
							this.props.isDetailsPage &&
							(
								this.props.tieredDetails ?
									(<div>
										{this.props.tieredHeaders}
										{this.props.tieredDetails}
									</div>) :
									this.buildContent()
							)
						}
					</div>

					<WayfindingModal
						isOpen={this.state.showWayfindingModal === true}
						listingUUID={this.state.wayfindingModalUUID}
						onClose={this.closeWayfindingModal}
						onListingChange={this.changeWayfindingModalListing}
						navEvents={this.props.navEvents}
						CSSModules={this.props.CSSModules}
						adaActive={this.props.navProps?.adaActive}
						systemUUID={this.props.system_uuid}
						systemGroupUUID={this.props.systemGroup}
						detailsGrp={this.state.wayfindingModalDetailsGrp}
						headerSettings={{
							showHeaders: this.props.details[this.props.details.length - 1]?.detailHeaders,
							labelSeparator: this.props.labelSeperator[this.props.details[this.props.details.length - 1]?.labelSeperator]
						}}
						settings={{
							locationMarkerUse: this.props.locationMarkerUse,
							locationMarkerColor: this.props.locationMarkerColor,
							locationMarkerSize: this.props.locationMarkerSize,
							mapDelayIn: this.props.mapDelayIn,
							mapDelayOut: this.props.mapDelayOut,
							pathColor: this.props.pathColor,
							pathEndmarker: this.props.pathEndmarker,
							pathEndmarkerSize: this.props.pathEndmarkerSize,
							pathWidth: this.props.pathWidth,
							wayfindingZoomPan: this.props.wayfinding_zoom_and_pan_on,
							// Journey panel + ETA (DEV-11822): TLC settings arriving via
							// getDefaultProps, same pipeline as wayfinding_zoom_and_pan_on.
							journeyPanel: this.props.wayfinding_journey_panel,
							journeyEta: this.props.wayfinding_eta,
							showInfoBox: this.props.wf_show_infobox,
						}}
						qrCodeText={this.getQRTextInstruction(this.getListingConfigUUID())}
					/>
				</div>
			</CSSTransition>

		);
	}
}

export default withTranslation()(Listings);
